import { Form, Image, Input } from 'antd'
import React from 'react'
import { StaticImages } from '../../../Utils/StaticImages'
import CustomButton from '../../../Components/CustomButton'
import { useDynamicMutationMutation } from '../../../redux/service/apiSlice'
import { Endpoints } from '../../../Utils/EndPoints'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { RouterKeys } from '../../../Routes/RouterKeys'

function ChangePassword() {

    const [form] = Form.useForm();
    const [changePasswordFunc, { isLoading }] = useDynamicMutationMutation();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        let payload = {
            "new_password": values?.new_password,  
            "old_password": values?.old_password   
        }
        try {
            const { data, error, } = await changePasswordFunc({
                endpoint: Endpoints.NON_AUTH.CHANGE_PASSWORD,
                method: 'POST',
                body: payload,
            });
            if (data) {
                toast.success('Password Changed Successfully', data?.message);
                navigate(RouterKeys.NON_Auth.DASHBOARD);
            } else {
                toast.error(error?.data?.message);
            }
        } catch (error) {
            toast.error(error.message || 'An unexpected error occurred.');
        }

    };
    const validateConfirmPassword = (_, value) => {
        const { new_password } = form.getFieldsValue();
        if (value && value !== new_password) {
            return Promise.reject(new Error('Confirmed and New  passwords do not match!'));
        }
        return Promise.resolve();
    };
    return (
        <>
            <p className="text-h2 font-bold mb-4 ">
                Change Password
            </p>

            <div className='shadow-cardCustom  rounded-20 p-4 pt-8'>

                <Form
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                    requiredMark={false}
                    className="auth_form_ss"
                    form={form}
                >
                    <Form.Item
                        label={<p className='auth_input_label'>Old Password</p>}
                        name="old_password"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter your old password!',
                            },
                        ]}
                    >
                        <Input.Password
                            size='large'
                            className='auth_input_ss cursorPointer'
                            placeholder="Enter the New Password..."
                            iconRender={(visible) => (visible ?
                                <Image
                                    src={StaticImages.Eye.openIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />
                                : <Image
                                    src={StaticImages.Eye.closeIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />)}

                        />
                    </Form.Item>
                    <Form.Item
                        label={<p className='auth_input_label'>New Password</p>}
                        name="new_password"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter your new password!',
                            },
                        ]}
                    >
                        <Input.Password
                            size='large'
                            className='auth_input_ss cursorPointer'
                            placeholder="Enter the New Password..."
                            iconRender={(visible) => (visible ?
                                <Image
                                    src={StaticImages.Eye.openIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />
                                : <Image
                                    src={StaticImages.Eye.closeIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />)}

                        />
                    </Form.Item>

                    <Form.Item
                        label={<p className='auth_input_label'>Confirm Password</p>}
                        name="confirmed_password"
                        rules={[
                            {
                                required: true,
                                message: 'Please confirm your new password!',
                            },
                            {
                                validator: validateConfirmPassword,
                            },
                        ]}
                    >
                        <Input.Password
                            size='large'
                            className='auth_input_ss cursorPointer'
                            placeholder="Confirm the New Password..."

                            iconRender={(visible) => (visible ?
                                <Image
                                    src={StaticImages.Eye.openIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />
                                : <Image
                                    src={StaticImages.Eye.closeIcon}
                                    alt='eyeopen'
                                    draggable={false}
                                    preview={false}
                                />)}
                        />
                    </Form.Item>
                    <Form.Item label={null}>
                        <CustomButton title="Update Password" htmlType="submit" className="commonButton mt-12"
                            loading={isLoading}
                        />
                    </Form.Item>
                </Form>
            </div>

        </>
    )
}

export default ChangePassword